import Client from "./base/client";

export class Common {
  private client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  private resourceUrl = "/api/v2";

  financeOption = <TData extends object>({
    amount,
    product,
    deposit,
  }: {
    amount: number;
    product: string;
    deposit: number;
  }): Promise<TData> => {
    const formData = new FormData();
    formData.append("amount", amount.toString());
    formData.append("product", product);
    formData.append("deposit", deposit.toString());
    return this.client.post(
      `${this.resourceUrl}/finance/option`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  };
}
